/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Unlock_TitleInputs */

const en_home_unlock_title = /** @type {(inputs: Home_Unlock_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Here's what you unlock`)
};

const fr_home_unlock_title = /** @type {(inputs: Home_Unlock_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voici ce que vous débloquez`)
};

/**
* | output |
* | --- |
* | "Here's what you unlock" |
*
* @param {Home_Unlock_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const home_unlock_title = /** @type {((inputs?: Home_Unlock_TitleInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Unlock_TitleInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_home_unlock_title(inputs)
	return fr_home_unlock_title(inputs)
});